import React from 'react';

import {
    Flex,
    Image,
    List,
    Spacer,
    Text,
} from '@zillow/constellation';

import ForSaleSign from 'app/shared/images/addPropertyPage/ForSaleSign.svg';

import { StyledDialogBodyContainer } from 'app/shared/containers/ModalContainer/StyledComponents';

const infoList = [
    'Renters will now see the Zillow Rental Manager version of the listing on Zillow, Trulia & HotPads',
    'This listing will be billed at your daily rate and included in your monthly invoice.',
];

const PreActivationModal = () => (
    <StyledDialogBodyContainer>
        <Spacer marginBottom="xs">
            <Flex display="flex" flexDirection="column" alignItems="center">
                <Spacer marginY="xs">
                    <Image src={ForSaleSign} alt="For sale sign" />
                </Spacer>
                <Spacer paddingBottom="sm">
                    <Text fontType="h6">
                        Things you need to know before publishing:
                    </Text>
                </Spacer>

                <List className="PreActivationModal-List">
                    {infoList.map((item, index) => (
                        <List.Item key={index}>{item}</List.Item>
                    ))}
                </List>
            </Flex>
        </Spacer>
    </StyledDialogBodyContainer>
);

export { PreActivationModal };
export default PreActivationModal;
